<template>
  <div class="container">
    <div class="handle-wrapper">
      <!-- <Input
        v-model="searchText"
        search
        placeholder="搜索储罐租借..."
        @on-enter="searchSacTankRental"
        style="width: 250px; margin-right: auto;"
      >
        <Button slot="append" icon="ios-search" @click="searchSacTankRental"></Button>
      </Input>-->
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="10"
        @on-change="loadSales"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button type="primary" @click="$refs.CreateSalesDrawer.openDrawer()">新增销售项目</Button>
    </div>
    <div class="table-wrapper">
      <Table :loading="tableLoading" :columns="columns" :data="tableData" width="1000">
        <template
          slot-scope="{ row }"
          slot="action"
          v-if="
            currentUser.superAdmin ||
            arrayIntersection(
              [
                'factoryLeader',
                'technologyLead',
                'technology',
                'allFactoryLeader',
              ],
              currentUser.simpleRole
            ).length > 0
          "
        >
          <Button
            type="info"
            ghost
            size="small"
            icon="ios-funnel"
            @click="$refs.RecipeDrawer.openDrawer(row)"
          >配方</Button>
        </template>
      </Table>
    </div>
    <CreateSalesDrawer ref="CreateSalesDrawer" />
    <RecipeDrawer ref="RecipeDrawer" />

    <!-- <AddTankRentalDrawer ref="AddTankRentalDrawer" :customerId="customerId" /> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CreateSalesDrawer from "../../../SalesPage/CreateSalesDrawer.vue";
import RecipeDrawer from "../../../SalesPage/RecipeDrawer.vue";
import dayjs from "dayjs";

export default {
  name: "SalesTabPane",
  props: ["customerId"],
  components: { CreateSalesDrawer, RecipeDrawer },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            )
        },
        {
          title: "项目代称",
          key: "abbr",
          render: (h, params) => {
            if (
              this.currentUser.superAdmin ||
              arrayIntersection(["salesAssist"], this.currentUser.simpleRole)
                .length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      cursor: "pointer",
                      color: "#42b983"
                    },
                    on: {
                      click: () => {
                        this.$refs.CreateSalesDrawer.openDrawer(params.row);
                      }
                    }
                  },
                  params.row.abbr
                    ? params.row.abbr
                    : params.row.customer.name +
                        " — " +
                        params.row.material.model
                )
              ]);
            } else {
              return h(
                "h4",
                params.row.abbr
                  ? params.row.abbr
                  : params.row.customer.name + " — " + params.row.material.model
              );
            }
          }
        },
        {
          title: "操作",
          key: "action",
          slot: "action",
          width: 90,
          align: "center"
        },
        {
          title: "客户",
          key: "customer",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small"
                  }
                },
                params.row.customer.name
              )
            ]);
          }
        },
        {
          title: "产品",
          key: "material",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              `${params.row.material.model} ${params.row.material.name}`
            )
        },
        {
          title: "发货工厂",
          key: "factory",
          width: 140,
          align: "left",
          render: (h, params) => h("span", `${params.row.factory.name}`)
        }
      ]
    };
  },
  computed: {
    ...mapState({
      tableData: state => state.sales.sales,
      totalRows: state => state.sales.totalCounts,
      currentUser: state => state.auth.currentUser
    })
  },
  methods: {
    ...mapActions({
      getSales: "sales/getSalesAction"
    }),
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    async loadSales(page) {
      if (page) this.page = page - 1;
      let api = {
        skip: this.page * 15,
        limit: 15,
        customer: this.customerId
      };
      if (this.searchText) api.cus_name = this.searchText;

      try {
        this.tableLoading = true;
        await this.getSales(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 1000px
  height 48px
  display flex
  justify-content flex-end

.table-wrapper
  height calc(100% - 48px)

.container
  width 100%
  margin-top 0 !important
</style>